import { type CSSProperties, type JSX, type ReactNode } from 'react';

import { MarginTablet, RowLayout } from './style';

export const GridLayout = ({
  children,
  className,
  id,
  numberOfCells,
  style,
}: {
  children?: ReactNode;
  className?: string;
  id?: string;
  numberOfCells: number;
  style?: CSSProperties;
}): JSX.Element => {
  return (
    <RowLayout className={className} data-testid={id} numberOfCells={numberOfCells} style={style}>
      {children}
      <MarginTablet />
    </RowLayout>
  );
};
